import { cva, type VariantProps } from 'class-variance-authority';
import { useState } from 'react';

const avatar = cva(
  'inline-flex items-center justify-center rounded-circle overflow-hidden shrink-0',
  {
    variants: {
      size: {
        xl: 'w-[64px] h-[64px] text-heading-m',
        large: 'w-[48px] h-[48px] text-heading-s',
        medium: 'w-[40px] h-[40px] text-body-l',
        small: 'w-[32px] h-[32px] text-body-s',
        xs: 'w-[24px] h-[24px] text-label',
      },
    },
    defaultVariants: { size: 'medium' },
  },
);

export type AvatarProps = VariantProps<typeof avatar> & {
  initials: string;
  src?: string;
};

export const Avatar = ({ src, initials, size = 'medium' }: AvatarProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div
      className={`${avatar({ size })} bg-neutral-subtle text-content-subdued relative`}
    >
      <span aria-hidden="true">{initials}</span>
      {src && (
        <img
          src={src}
          alt=""
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(false)}
          className={`absolute inset-0 w-full h-full object-cover object-center bg-surface transition-opacity ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
        />
      )}
    </div>
  );
};
